/**
 * Schedule + interval row for multi-country shared configuration.
 */

import { DateTimePicker, TimeIntervalPicker } from '@/components/ui';
import {
  scheduleLocalToUtcIso,
  utcIsoToScheduleLocal,
} from '@/features/smswiser-campaigns/utils/scheduleTimezone';

import { ScheduleModeRadios } from './ScheduleModeRadios';

import type { useMultiCountryBulkEditForm } from '@/features/smswiser-campaigns/components/MultiCountryBulkEdit/hooks';

type Form = ReturnType<typeof useMultiCountryBulkEditForm>;

interface Props {
  form: Form;
  isBusy: boolean;
}

export function SharedScheduleBlock({ form, isBusy }: Props) {
  const apply = form.scheduleMode === 'apply';
  const clearing = form.scheduleMode === 'clear';

  return (
    <div className="space-y-3">
      <ScheduleModeRadios value={form.scheduleMode} onChange={form.setScheduleMode} disabled={isBusy} />
      {apply && (
        <div className="space-y-2 rounded-md border border-border/50 bg-muted/10 p-3">
          <label className="block text-xs text-muted-foreground">Date & time</label>
          <DateTimePicker
            value={form.executeAfter ? utcIsoToScheduleLocal(form.executeAfter) : ''}
            onChange={(v) => form.setExecuteAfter(v ? scheduleLocalToUtcIso(v) : '')}
            placeholder="dd/mm/yyyy, --:--"
            disabled={isBusy}
            minDateToday
            ariaLabel="Schedule drop"
            className="w-full"
          />
          <div>
            <label className="mb-1 block text-xs text-muted-foreground">
              Interval <span className="text-muted-foreground/80">(hh:mm)</span>
            </label>
            <TimeIntervalPicker
              value={form.scheduleInterval || '00:00'}
              onChange={form.setScheduleInterval}
              disabled={isBusy || !form.executeAfter}
            />
          </div>
        </div>
      )}
      {clearing && (
        <p className="text-xs text-muted-foreground">
          When you save, scheduled send times will be removed from every draft included in this bulk edit.
        </p>
      )}
    </div>
  );
}
